import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import * as R from "ramda";
import $ from 'jquery';

import { ServiceModal } from './serviceModal';
import { ServiceTable } from './table';
import { useDispatch } from 'react-redux';
import { resetServices, fetchServices, deleteService } from '../../../actions/backoffice/configuration';
import { EditServiceModal } from './editServiceModal';
import { DeleteServiceModal } from './deleteServiceModal';

import { AssuranceOptionsBO, AuxiliarOptions, CommonServices, ConnectionTypes, FrenchTypes, OtherService, PersonalServices } from '../../../constants/utils/connectionTypes';


export const ConfigurationServices = ({ configState }) => {

	let dispatch = useDispatch();
	const history = useHistory();
	const searchQuery = useLocation();
	const pageQuery = new URLSearchParams(searchQuery.search);

	let search = pageQuery.get('search');
	let page = pageQuery.get('page');
	let serviceType = pageQuery.get('serviceType');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');
	let lifeEvent = pageQuery.get("lifeEvent");

	search = R.isNil(search) ? '' : search;
	page = R.isNil(page) ? 1 : parseInt(page);
	sortBy = R.isNil(sortBy) ? "" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "false" : sortDesc;
	serviceType = R.isNil(serviceType) ? configState.serviceType : serviceType;
	lifeEvent = R.isNil(lifeEvent) ? "Death" : lifeEvent;

	const [selectedService, setSelectedService] = useState({});
	const [pageSearch, setPageSearch] = useState(search);
	const renderRef = useRef(false);


	const handleDeleteService = (service)=>{
		dispatch(deleteService(service));
		dispatch(fetchServices(serviceType, page, search, sortBy, sortDesc, lifeEvent));
	}


	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			history.push("/backoffice/configuration/services");
			return;
		}

		if (R.isNil(serviceType) || R.isEmpty(serviceType)) {
			dispatch(resetServices());
			return;
		}

		//servicetype, pageNumber, searchTerm, sortByTerm, sortDesc, lifeEvent
		dispatch(fetchServices(serviceType, page, search, sortBy, sortDesc, lifeEvent));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchQuery.search, history.location]);


	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};

		if (R.isEmpty(pageSearch)) {
			history.push(`/backoffice/configuration/services?page=${1}${serviceType !== "" ? "&serviceType=" + serviceType : ""}${lifeEvent && lifeEvent !== "" ? "&lifeEvent=" + lifeEvent : ""}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(fetchServices(serviceType, page, pageSearch, sortBy, sortDesc, lifeEvent));
		}, 1000);


		return () => clearTimeout(timer);

		// eslint-disable-next-line 
	}, [pageSearch]);


	const routerQuery = {
		page,
		search,
		sortBy,
		sortDesc,
		serviceType,
		lifeEvent
	};

	const servicesToDelete = [ConnectionTypes.locataire, ConnectionTypes.ehpad, ConnectionTypes.activity, ConnectionTypes.otherActivity, ConnectionTypes.etudiant];
	let allServices = [...Object.values(PersonalServices), ...Object.values(CommonServices), ...Object.values(OtherService), ...Object.values(AssuranceOptionsBO), { connectionType: "SocialNetwork", title: "Reseaux Sociaux" }];
	allServices = allServices.map(s => ({ ...s, normalizedTitle: s.title.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase() }))
		.filter(srv => !servicesToDelete.includes(srv.connectionType));

	return (
		<React.Fragment>
			<div className="auto-view h-100 mb-auto">
				<ServiceTable configState={configState} setPageSearch={setPageSearch} pageSearch={pageSearch} setSelectedService={setSelectedService} routerQuery={routerQuery} allServices={allServices} />
				<ServiceModal allServices={allServices} serviceType={routerQuery.serviceType} lifeEvent={routerQuery.lifeEvent} />
				<EditServiceModal selectedService={selectedService} configState={configState} allServices={allServices} serviceType={routerQuery.serviceType} lifeEvent={routerQuery.lifeEvent} />
				<DeleteServiceModal selectedService={selectedService} deleteService={handleDeleteService} />
			</div>
			{
				<div className="container-fluid">
					<div className="flex-row my-3 justify-content-center">
						{configState.currentPage > 1 ? (
							<Link
								to={`/backoffice/configuration/services?page=${1}${configState.serviceType !== "" ? "&serviceType=" + configState.serviceType : ""}${pageSearch !== "" ? "&search=" + pageSearch : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}${
									configState.lifeEvent && configState.lifeEvent !== "" ? "&lifeEvent=" + configState.lifeEvent : ""
								}`}
								className={"btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
								<i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i>
							</Link>
						) : (
							<button disabled className={"btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
								<i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i>
							</button>
						)}
						{configState.currentPage > 1 ? (
							<Link
								to={`/backoffice/configuration/services?page=${configState.currentPage - 1}${configState.serviceType !== "" ? "&serviceType=" + configState.serviceType : ""}${pageSearch !== "" ? "&search=" + pageSearch : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${
									sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"
								}${configState.lifeEvent && configState.lifeEvent !== "" ? "&lifeEvent=" + configState.lifeEvent : ""}`}
								className={"btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
								<i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i>
							</Link>
						) : (
							<button disabled className={"btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
								<i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i>
							</button>
						)}

						<button className="btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
							{configState.currentPage} de {configState.totalPages}
						</button>

						{configState.currentPage < configState.totalPages ? (
							<Link
								to={`/backoffice/configuration/services?page=${configState.currentPage + 1}${configState.serviceType !== "" ? "&serviceType=" + configState.serviceType : ""}${pageSearch !== "" ? "&search=" + pageSearch : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${
									sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"
								}${configState.lifeEvent && configState.lifeEvent !== "" ? "&lifeEvent=" + configState.lifeEvent : ""}`}
								className="btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
								<i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i>
							</Link>
						) : (
							<button disabled className="btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
								<i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i>
							</button>
						)}
						{configState.currentPage < configState.totalPages ? (
							<Link
								to={`/backoffice/configuration/services?page=${configState.totalPages}${configState.serviceType !== "" ? "&serviceType=" + configState.serviceType : ""}${pageSearch !== "" ? "&search=" + pageSearch : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${
									sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}${configState.lifeEvent && configState.lifeEvent !== "" ? "&lifeEvent=" + configState.lifeEvent : ""}`}
								className="btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
								<i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i>
							</Link>
						) : (
							<button disabled className="btn rounded-0 bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
								<i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i>
							</button>
						)}
					</div>
				</div>
			}
		</React.Fragment>
	);
};